import { TextField } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import "./inputs.css";

const DefaultMultipleRowInput = ({ 
  label, 
  value, 
  onChange, 
  disabled = false, 
  rows = 4,
  style = {}
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      className={"default__input"}
      onChange={(event) => onChange(event.target.value)}
      label={t(label)}
      value={value}
      disabled={disabled}
      multiline
      rows={rows}
      style={{
        ...style
      }}
      InputProps={{
        style: {
          wordBreak: "break-all",
          whiteSpace: "pre-wrap",
          alignItems: "flex-start",
          minHeight: rows * 20 + 30 + "px"
        }
      }}
    />
  );
};

export default DefaultMultipleRowInput;